export default function loadZen (zenKey, locale, callback) {
  /* eslint-disable */
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s);
    j.async = true;
    j.src = 'https://static.zdassets.com/ekr/snippet.js?key=' + zenKey;
    j.id = 'ze-snippet';
    j.onload = function () {
      if (zE) {
        zE('webWidget', 'setLocale', locale);
        if (callback) callback();
      }
    };

    f.parentNode.insertBefore(j, f);

  })(window, document, 'script', 'https://static.zdassets.com/ekr/snippet.js?key=' + zenKey);
  /* eslint-enable */
}
